import React from "react";

import { faSteak } from "@fortawesome/pro-regular-svg-icons";
import { Grid } from "@material-ui/core";
import range from "lodash/range";

import { Input } from "components/Form/FormikControls";
import { Row } from "components/Layout";
import { Paper } from "components/Paper";
import { MediumText as Heading } from "components/Text";

import { Error, Icon } from "./components";

export const MuscleScoreSection = ({ errorMessage, maxScore, readOnly }) => (
  <Grid item xs={12}>
    <Paper>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Row flexGrow>
            <Icon icon={faSteak} color="gray44" />
            <Heading>Muscle Score (hd)</Heading>
            {errorMessage && <Error>{errorMessage}</Error>}
          </Row>
        </Grid>
        {/* range is inclusive of the lower bound and exclusive of the upper bound, add 1 to compensate */}
        {range(1, maxScore + 1).map(i => (
          <Grid item xs key={i}>
            <Input
              label={`Score ${i}`}
              name={`draftingAttributes.muscleScore${i}`}
              type="number"
              emptyValue={null}
              disabled={readOnly}
            />
          </Grid>
        ))}
      </Grid>
    </Paper>
  </Grid>
);
